import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

interface Props {
  isActive?: boolean;
}

const Group = styled.div`
  width: 100%;
  margin: auto;
  position: relative;
  min-height: 100%;
`;

const DropOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--background-primary);
  opacity: 0.96;
  border: 2px dashed var(--brand-primary);
  border-radius: var(--border-radius-8);
  height: calc(100dvh - 4px);
`;

const DropMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
  text-align: center;
`;

const DropTitle = styled.p`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: var(--space-0);
  margin-top: var(--space-8);
`;

const DropText = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-24);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(186px, 1fr));
  grid-template-rows: auto;
  ${mobile_xl(css`
    gap: var(--space-16);
    grid-template-columns: repeat(auto-fill, minmax(128px, 1fr));
    .file-data-image {
      width: 53px;
      height: 53px;
    }
  `)}
`;

const FileDetails = styled.div`
  padding: var(--space-24);
  ${mobile_xl(css`
    padding: var(--space-8) var(--space-20) var(--space-96);
    .loading-image {
      display: none;
    }
  `)}
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-10);
  ${mobile_xl(css`
    position: absolute;
    bottom: 96px;
    right: 40px;
    gap: var(--space-12);
    align-items: flex-end;
    padding-left: var(--space-10);
  `)}
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--space-5);
  margin-top: var(--space-40);
  ${mobile_xl(css`
    align-items: flex-start;
    max-width: 193px;
    width: 100%;
    gap: var(--space-0);
    margin-top: var(--space-0);
  `)}
`;

const Title = styled.h1`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const Text = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  white-space: nowrap;
  margin: var(--space-0);
  ${mobile_xl(css`
    white-space: normal;
  `)}
`;

const Icon = styled.div`
  cursor: pointer;
  display: flex;
  gap: var(--space-14);
  &:hover .fillColor {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-4);
  }
  ${mobile_xl(css`
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
  .fillColor {
    stroke: var(--text-primary);
  }
`;

const RightSide = styled.div`
  .mobile-view {
    display: none;
  }
  .web-view {
    path {
      stroke: var(--brand-primary);
    }
    path.circle-fill {
      fill: var(--background-primary);
    }
  }
  ${mobile_xl(css`
    .web-view {
      display: none;
    }
    .mobile-view {
      display: block;
      path {
        stroke: var(--brand-primary);
      }
      path.circle-fill {
        fill: var(--background-primary);
      }
    }
  `)}
`;

const BreadCrumb = styled.div`
  display: flex;
`;

const BreadCrumbContent = styled.div`
  display: flex;
`;

const BredCrumbBlock = styled.div<Props>`
  padding: var(--space-4) var(--space-8);
  ${Typography.body_md}
  color: ${({ isActive }) => (isActive ? 'var(--brand-primary)' : 'var(--text-primary)')};
  cursor: pointer;
  &:hover {
    color: var(--text-secondary);
  }
`;

const BreadSlash = styled.div`
  padding-block: var(--space-4);
  ${Typography.body_md}
  color: var(--text-primary);
  margin-inline: var(--space-2);
`;

const FileIconDiv = styled.div`
  position: relative;
  .file-text {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 35%;
    left: 25%;
    width: 50%;
    font-weight: 700;
    color: var(--text-secondary);
  }
`;

const InputDiv = styled.div`
  position: relative;
`;

const SelectedText = styled.div`
  position: absolute;
  top: 8px;
  left: 12px;
  pointer-events: none;
  color: var(--text-primary);
  ${Typography.body_lg}
`;

export {
  Group,
  DropOverlay,
  DropMessage,
  DropTitle,
  DropText,
  Container,
  Content,
  LeftSide,
  Title,
  Text,
  Icon,
  RightSide,
  BreadCrumb,
  BreadCrumbContent,
  BredCrumbBlock,
  BreadSlash,
  FileDetails,
  FileIconDiv,
  InputDiv,
  SelectedText
};
